export const appConfig = {
  service: {
    google: {
      recaptchaClientId:
        '262976645210-77e70hdfjdan8pfns9afgp9b9r6l6ed7.apps.googleusercontent.com',
    },
  },
}
